import type { VoidFunctionComponent } from 'react';
import type Stripe from 'stripe-latest';
import { GreenCheck } from '../../generic';
import { ICON_SIZE } from '../../generic/Icon/icon-constants';
import Flex from '../../generic/Flex';
import { isBusinessPlan, isEnterprisePlan } from './utils';
import styles from './style.module.less';

type FeaturesComponentProps = {
  product: Stripe.Product,
};

const getFeaturesTitle = (product: Stripe.Product) => {
  if (isBusinessPlan(product)) {
    return 'Everything in Free, plus:';
  }

  if (isEnterprisePlan(product)) {
    return 'Everything in Business, plus:';
  }

  return 'Features';
};

const FeaturesComponent: VoidFunctionComponent<FeaturesComponentProps> = ({
  product,
}) => {
  if (!product) {
    return null;
  }

  const features = Object.keys(product.metadata)
    .filter(key => /^feature_\d+$/.test(key)) // Only include keys starting with 'feature_' and ending with a number
    .sort((a: string, b: string) => {
      const orderA = parseInt(a.split('_')[1] || '0', 10);
      const orderB = parseInt(b.split('_')[1] || '0', 10);
      return orderA - orderB;
    })
    .map(key => product.metadata[key]);

  return (
    <div className={styles.featuresContainer}>
      <div className={styles.featuresTitle}>
        {getFeaturesTitle(product)}
      </div>
      {features.map((feature) => (
        <div key={feature}>
          <Flex justify="flex-start" align="flex-start" gap={12}>
            <GreenCheck size={ICON_SIZE.LG} />
            <div>{feature}</div>
          </Flex>
        </div>
      ))}
    </div>
  );
};

export default FeaturesComponent;
